export const actionTypes = {
    SET: 'COOKIES_SET'
};

export const setCookie = (name, value) => ({
    type: actionTypes.SET,
    payload: {
        name: name,
        value: value
    }
});

export default {
    actionTypes,
    setCookie
};
